import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["name", "readonly", "disabled", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: $setup.blockClasses }, { 'aria-disabled': $props.disabled }), [
    _createElementVNode("span", {
      class: _normalizeClass([`${$props.blockName}__body`])
    }, [
      _renderSlot(_ctx.$slots, "prepend"),
      ($props.startIcon || _ctx.$slots.startIcon)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([`${$props.blockName}__element`, `${$props.blockName}__element--attachment_prepend`])
          }, [
            _renderSlot(_ctx.$slots, "startIcon", {}, () => [
              _createVNode(_component_AppIcon, {
                name: $props.startIcon,
                size: $props.iconSize
              }, null, 8, ["name", "size"])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", _mergeProps({
        class: [`${$props.blockName}__element`, `${$props.blockName}__element--primary`],
        ref: "autocompleteInput"
      }, _ctx.$attrs, {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.internal) = $event)),
        name: $props.name,
        readonly: $props.readonly,
        disabled: $props.disabled,
        type: "text",
        placeholder: _ctx.$attrs.placeholder || '',
        autocomplete: "off",
        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
        onBlur: $setup.blur
      }), null, 16, _hoisted_1), [
        [_vModelText, $setup.internal]
      ]),
      ($props.endIcon || _ctx.$slots.endIcon)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass([`${$props.blockName}__element`, `${$props.blockName}__element--attachment_append`])
          }, [
            _renderSlot(_ctx.$slots, "endIcon", {}, () => [
              _createVNode(_component_AppIcon, {
                name: $props.endIcon,
                size: $props.iconSize
              }, null, 8, ["name", "size"])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "append")
    ], 2)
  ], 16))
}